var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 1.1547C13.4876 0.440169 15.0124 0.440169 16.25 1.1547L24.3744 5.8453C25.612 6.55983 26.3744 7.88034 26.3744 9.3094V18.6906C26.3744 20.1197 25.612 21.4402 24.3744 22.1547L16.25 26.8453C15.0124 27.5598 13.4876 27.5598 12.25 26.8453L4.12564 22.1547C2.88804 21.4402 2.12564 20.1197 2.12564 18.6906V9.3094C2.12564 7.88034 2.88804 6.55983 4.12564 5.8453L12.25 1.1547Z",
    fill: "url(#paint0_linear_870_1235)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 3.1547C13.4876 2.44017 15.0124 2.44017 16.25 3.1547L22.6423 6.8453C23.8799 7.55983 24.6423 8.88034 24.6423 10.3094V17.6906C24.6423 19.1197 23.8799 20.4402 22.6423 21.1547L16.25 24.8453C15.0124 25.5598 13.4876 25.5598 12.25 24.8453L5.8577 21.1547C4.62009 20.4402 3.8577 19.1197 3.8577 17.6906V10.3094C3.8577 8.88034 4.62009 7.55983 5.8577 6.8453L12.25 3.1547Z",
    fill: "url(#paint1_linear_870_1235)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 4.1547C13.4876 3.44017 15.0124 3.44017 16.25 4.1547L21.7763 7.3453C23.0139 8.05983 23.7763 9.38034 23.7763 10.8094V17.1906C23.7763 18.6197 23.0139 19.9402 21.7763 20.6547L16.25 23.8453C15.0124 24.5598 13.4876 24.5598 12.25 23.8453L6.72372 20.6547C5.48612 19.9402 4.72372 18.6197 4.72372 17.1906V10.8094C4.72372 9.38034 5.48612 8.05983 6.72372 7.3453L12.25 4.1547Z",
    fill: "url(#paint2_linear_870_1235)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 6.1547C13.4876 5.44017 15.0124 5.44017 16.25 6.1547L20.0442 8.3453C21.2818 9.05983 22.0442 10.3803 22.0442 11.8094V16.1906C22.0442 17.6197 21.2818 18.9402 20.0442 19.6547L16.25 21.8453C15.0124 22.5598 13.4876 22.5598 12.25 21.8453L8.45577 19.6547C7.21817 18.9402 6.45577 17.6197 6.45577 16.1906V11.8094C6.45577 10.3803 7.21817 9.05983 8.45577 8.3453L12.25 6.1547Z",
    fill: "url(#paint3_linear_870_1235)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9746 19V17.3867C11.7174 16.7624 12.3942 16.1654 13.0049 15.5957C13.6156 15.026 14.0872 14.5544 14.4199 14.1807C14.7526 13.8024 15.0101 13.4424 15.1924 13.1006C15.3792 12.7542 15.4727 12.3919 15.4727 12.0137C15.4727 11.7174 15.361 11.4827 15.1377 11.3096C14.9144 11.1364 14.6068 11.0498 14.2148 11.0498C13.791 11.0498 13.4447 11.1478 13.1758 11.3438C12.9069 11.5397 12.6836 11.7721 12.5059 12.041L10.9473 10.9473C11.3346 10.3685 11.7926 9.95605 12.3213 9.70996C12.8545 9.46387 13.5176 9.34082 14.3105 9.34082C15.2858 9.34082 16.0537 9.56868 16.6143 10.0244C17.1794 10.4801 17.4619 11.1204 17.4619 11.9453C17.4619 12.5514 17.3503 13.0846 17.127 13.5449C16.9082 14.0007 16.5938 14.445 16.1836 14.8779C15.778 15.3063 15.2699 15.7803 14.6592 16.2998C14.0531 16.8193 13.6794 17.1315 13.5381 17.2363H17.7695V19H10.9746Z",
    fill: "#829FBA"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_870_1235",
    x1: 0.25,
    y1: 0,
    x2: 28.25,
    y2: 28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E8EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B0BAC3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_870_1235",
    x1: 2.25,
    y1: -7.94729e-8,
    x2: 26.25,
    y2: 28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3ADB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDE6EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_870_1235",
    x1: 6.25,
    y1: 1.5,
    x2: 22.75,
    y2: 25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#99B0C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#829FBA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_870_1235",
    x1: 5.25,
    y1: 5,
    x2: 21.9,
    y2: 23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4F8FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCE3E9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwo);
export default __webpack_public_path__ + "static/media/two.ac8b67897c3f4590f46f7c5c570e9a8e.svg";
export { ForwardRef as ReactComponent };